module.exports = __webpack_public_path__ + "img/divanul-1698-pagina-de-titlu-big.0881577c.jpg";